import { createFileRoute } from '@tanstack/react-router';

import { Continuity } from '@/view/pages/Decoupages/Continuity';

export const Route = createFileRoute('/_protected/$programId/decupagens/continuidade')({
  component: Continuity,
  context: (context): { title: string } => ({
    ...context,
    title: 'Decupagem de Continuidade',
  }),
});
